module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/erin-holler-9525b972871feb6e326bb767d3174d3e.jpg";